import React from 'react';
import {injectIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';
import FormGroupField from '../FormGroupField';

export const MappParameters = ({provider}) => {
    return (
        <>
            <div className="col">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-baseURL"
                    name="parameters.baseURL"
                    label={messages.admin.organization.sendProviders[provider].parameters.baseURL} />
            </div>
            <div className="col">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-user"
                    name="parameters.user"
                    label={messages.admin.organization.sendProviders[provider].parameters.user} />
            </div>
            <div className="col">
                <FormGroupField type="password"
                    id="uef-organization-sendProvider-parameters-password"
                    name="parameters.password"
                    label={messages.admin.organization.sendProviders[provider].parameters.password} />
            </div>
            <div className="col">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-groupId"
                    name="parameters.groupId"
                    label={messages.admin.organization.sendProviders[provider].parameters.groupId} />
            </div>
            <div className="col">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-smsChannelId"
                    name="parameters.smsChannelId"
                    label={messages.admin.organization.sendProviders[provider].parameters.smsChannelId} />
            </div>
        </>
    );
};

export default injectIntl(MappParameters);
